/* @flow */
// typecheck: ignore file
import React from 'react';
import ActivityAnnouncementTeacherComposer from 'payments/components/ActivityAnnouncementTeacherComposer.jsx';
import GroupActions from 'groups/actions/GroupActions';
import SetUserEmailModal from 'settings/components/SetUserEmailModal.jsx';
import { mountModal } from 'lib/modal';
import User from 'entities/User';
import Dialog from 'components/Dialog.jsx';
import ConfirmDialog from 'components/ConfirmDialog.jsx';

import type {PublicState as ComposerPublicState} from 'payments/components/ActivityAnnouncementTeacherComposer.jsx'; // eslint-disable-line

import './styles/ActivityCreateDialog.scss';

type Props = {
  currentUser: User,
  onRequestHide?: () => any,
  onActivitySent?: ?Function,
  defaultGroupCodes: string[],
  createParams?: ?Object,
};

function CloseDialogConfirmationDialog(props) {
  return (
    <ConfirmDialog
      eventScreenName="ActivityCreateDialog"
      hideCloseButton
      title="Would you like to close out of creating an activity"
      subtext="Your progress will not be saved"
      actionButtonText="Yes"
      cancelButtonText="Cancel"
      {...props}
    />
  );
}

class ActivityCreateDialog extends React.Component {
  props: Props;

  /* This is kinda weird, this is to make
   * sure all groups are loaded for the recipient picker
   * further down in ActivityAnnouncementTeacherComposer
   * It needs to be move in the recipient picker component.
   */
  componentDidMount() {
    GroupActions.loadGroups();
  }

  onActivitySent = () => {
    if (this.props.onRequestHide) {
      this.props.onRequestHide();
    }

    if (this.props.onActivitySent) {
      this.props.onActivitySent();
    }
  }

  onDialogRequestHide = () => {
    const close = this.props.onRequestHide || (() => {});
    const state: ComposerPublicState = this.getComposerState();

    // if user selected a type (which is the first screen)
    // we prompt a confirm dialog before closing the activity dialog
    if (state.type) {
      mountModal(<CloseDialogConfirmationDialog onConfirm={close} />, this);
    } else {
      close();
    }
  }

  /* Return the public state of the composer
   * This is a function because I just wanted an
   * easy way to stub the ref for shallow render.
   */
  getComposerState(): ComposerPublicState {
    return this.refs.activity_composer.getWrappedInstance().getPublicState();
  }

  /* Render the user email form.
   * There's no callback here, SetUserEmailModal will
   * update the CurrentUser store and ActivityCreateDialogContainer
   * will update and re-render ActivityCreateDialog.
   */
  renderRequireEmailView() {
    return (
      <SetUserEmailModal
        {...this.props}
        closeOnSave={false}
        message="An email address is required to create an activity. This will be your primary email address for Remind."
      />
    );
  }

  render() {
    if (!this.props.currentUser.hasEmail()) {
      return this.renderRequireEmailView();
    }

    return (
      <Dialog
        {...this.props}
        onRequestHide={this.onDialogRequestHide}
        className="ActivityCreateDialog"
        size="medium">
        <ActivityAnnouncementTeacherComposer
          ref="activity_composer"
          onActivitySent={this.onActivitySent}
          defaultGroupCodes={this.props.defaultGroupCodes}
          initialState={this.props.createParams || undefined}
        />
      </Dialog>
    );
  }
}

export default ActivityCreateDialog;



// WEBPACK FOOTER //
// ./src/payments/components/ActivityCreateDialog.jsx